var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"virHome"},[_c('VirHomePart1'),_c('VirHomePart2'),_c('VirHomePart3'),_c('VirHomePart4'),_c('VirHomePart5'),_c('VirHomePart6'),_c('VirHomePart7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }